import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import React, { FunctionComponent } from 'react';

export const I18nProviderWrapper: FunctionComponent = ({ children }) => {
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};
